/* eslint-disable import/no-cycle */
import AdHocPurchase from '@/api/AdHocPurchase';
import Application from '@/api/Application';
import Auth from '@/api/Auth';
import Customer from '@/api/Customer';
import Devtool from '@/api/Devtool';
import Salesforce from '@/api/Salesforce';
import Search from '@/api/Search';
import User from '@/api/User';
import Validate from '@/api/Validate';
/* eslint-enable import/no-cycle */

export default class API {
    static adHocPurchase = AdHocPurchase;

    static application = Application;

    static auth = Auth;

    static customer = Customer;

    static devtool = Devtool;

    static salesforce = Salesforce;

    static search = Search;

    static user = User;

    static validate = Validate;
}
